/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/jsx-closing-bracket-location */
import React, { ReactElement } from 'react';

interface IDropdownList {
  name: string;
  index: number;
  selectItem: (arg: number) => void;
}

const DropdownList = ({ name, index, selectItem }: IDropdownList): ReactElement => {
  return (
    <button
      type="button"
      className="dropdown-list-item"
      key={index}
      onClick={() => selectItem(index)}>
      {name}
    </button>
  );
};

export default DropdownList;
